var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"co-upload-envelope"},[(!_vm.possuiPdf)?_c('envelope',{on:{"exibir-lista-pdf":_vm.adicionarPdfs}}):_c('lista-pdf',{attrs:{"pdfs":_vm.pdfs},on:{"adicionar-pdf":_vm.adicionarPdfs,"remover-pdf":_vm.removerPdf}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }